import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN } from './cardCoversSpotlight.constants.tsx';
import type { Props, State } from './GlobalFieldsTourSteps.types.tsx';
import { maybeWaitForPremiumModal } from './maybeWaitForPremiumModal.tsx';

export const loadConnectionsSpotlightSeen =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		await maybeWaitForPremiumModal(getState);

		if (typeof getState().timeline.connectionsSpotlightSeen === 'boolean') {
			return;
		}

		try {
			const connectionsSpotlightSeen = await getUserProperty<boolean>(
				accountId,
				TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN,
			);

			const state = getState();

			setState({
				timeline: {
					...state.timeline,
					connectionsSpotlightSeen,
				},
			});
		} catch (error) {
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					timeline: {
						...state.timeline,
						connectionsSpotlightSeen: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.timeline.connections-spotlight',
				`Failed to get user property with key: ${TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN}`,
				error instanceof Error ? error : undefined,
			);
		}
	};

export const setConnectionsSpotlightSeen =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();

		setState({
			timeline: {
				...state.timeline,
				connectionsSpotlightSeen: true,
			},
		});

		try {
			await setUserProperties(accountId, TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN, 'true');
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.timeline.connections-spotlight',
				`Failed to set user property with key: ${TIMELINE_CONNECTIONS_SPOTLIGHT_SEEN}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
